import script from "./PosterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PosterPage.vue?vue&type=script&setup=true&lang=js"

import "./PosterPage.vue?vue&type=style&index=0&id=24a58416&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24a58416"]])

export default __exports__